import { Link } from "react-router-dom";
import { Logo } from "./Icons";

const cols = [
  {
    title: "Solutions",
    links: [
      { name: "All Products", path: "/products" },
      { name: "Batching Plants", path: "/products" },
      { name: "Concrete Mixers", path: "/products" },
      { name: "Construction Equipment", path: "/products" },
    ],
  },
  {
    title: "Company",
    links: [
      { name: "About Us", path: "/about" },
      { name: "Careers", path: "/careers" },
      { name: "Global Projects", path: "/#projects" },
      { name: "Contact", path: "/contact" },
    ],
  },
];

export function Footer() {
  return (
    <footer id="contact" className="bg-slate-950 text-slate-400">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr_1.3fr]">
          <div>
            <Logo isDarkTheme />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
              Established in 1976, Technostud Engineering manufactures and
              exports advanced construction machinery built to international
              quality standards.
            </p>
            <div className="mt-5 flex gap-3">
              {["in", "X", "f"].map((s) => (
                <a
                  key={s}
                  href="#"
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-white/15 text-sm font-bold transition hover:border-teal-400 hover:text-teal-400"
                >
                  {s}
                </a>
              ))}
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold uppercase tracking-wider text-white">
                {col.title}
              </h4>
              <ul className="mt-5 space-y-3 text-sm">
                {col.links.map((l) => {
                  return (
                    <li key={l.name}>
                      {l.path.startsWith("/#") ? (
                        <a href={l.path} className="transition hover:text-teal-400">
                          {l.name}
                        </a>
                      ) : (
                        <Link to={l.path} className="transition hover:text-teal-400">
                          {l.name}
                        </Link>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">
              Contact
            </h4>
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex gap-3">
                <svg className="mt-0.5 h-5 w-5 shrink-0 text-teal-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 21s-7-5.5-7-11a7 7 0 1 1 14 0c0 5.5-7 11-7 11Z" />
                  <circle cx="12" cy="10" r="2.5" />
                </svg>
                <span>
                  Plot No.413, Road No.10, G.I.D.C.,<br />
                  Kathwada, Ahmedabad – 382 430, India.
                </span>
              </li>
              <li className="flex gap-3">
                <svg className="h-5 w-5 shrink-0 text-teal-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 0 1 2-2h2l2 5-2 1a11 11 0 0 0 5 5l1-2 5 2v2a2 2 0 0 1-2 2A16 16 0 0 1 3 5Z" />
                </svg>
                <span>(+91) 9313286536</span>
              </li>
              <li className="flex gap-3">
                <svg className="h-5 w-5 shrink-0 text-teal-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
                  <rect x="3" y="5" width="18" height="14" rx="2" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="m3 7 9 6 9-6" />
                </svg>
                <span>
                  technostud@yahoo.com<br />technostud@gmail.com
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-5 text-xs sm:flex-row">
          <span>© {new Date().getFullYear()} Technostud Engineering. All Rights Reserved.</span>

        </div>
      </div>
    </footer>
  );
}
